import { BusinessLookupEligible, BusinessSubmitRequest } from './contract';

interface BuildBusinessSubmitRequestInput {
    verificationToken: string;
    response: BusinessLookupEligible;
    idempotencyKey: string;
}

/**
 * The body of the business submit, nothing else: the session credential, the
 * digits-only CUI, the verification reference and the idempotency key. BOLT owns
 * the company data; `invoiceIdentifier` (which may carry an RO prefix) is never
 * sent. The same inputs always produce an identical body.
 */
export const buildBusinessSubmitRequest = (input: BuildBusinessSubmitRequestInput): BusinessSubmitRequest => ({
    verificationToken: input.verificationToken,
    business: {
        cui: input.response.company.tax.cui,
        verificationReference: input.response.verification.reference,
    },
    idempotencyKey: input.idempotencyKey,
});
